import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Input from '../input';
import Popup from './';
import Checkbox from '../checkbox';
import RoundCheck from '../round-check';

class VerifyPopup extends Component {
  static propTypes = {
    route: PropTypes.objectOf(PropTypes.string).isRequired,
    name: PropTypes.string,
  };

  static defaultProps = {
    name: '',
  };

  state = {
    sendData: false,
    error: null,
    success: false,
    file: null,
    key: 0,
  };

  // Получаем данные
  loadData() {
    const {
      route: { user },
    } = this.props;
    const { sendData } = this.state;
    const self = this;

    let headers = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    if (process.env.NODE_ENV != 'dev') {
      headers.credentials = 'include';
    } else {
      headers.headers.authorization = getAuth();
    }

    fetch(user, headers)
      .then(response => response.json())
      .then(json => {
        if (json.status == 'success') {
          if (sendData) {
            this.showPopup('success', 'Ваши данные успешно сохранены.');
            this.setState({
              sendData: false,
              key: this.state.key + 1,
              data: json.data,
              error: null,
              success: true,
            });
          } else {
            let err = 'Что-то пошло не так. Попробуйте еще раз.';

            if ('message' in json.errors) {
              err = json.errors.message;
            } else if ('join' in json.errors && json.errors.length > 0) {
              err = `${json.errors[0].title + '. ' || ''}${json.errors[0]
                .detail || 'Что-то пошло не так. Попробуйте еще раз.'}`;
            }

            this.setState({
              loading: false,
              data: json.data,
              birthday: json.data && json.data.birthday,
              oldData: json.data,
              deleteAvatar: !json.data.avatar,
              error: err,
            });
          }
        } else if (json.status == 'error') {
          if (sendData) {
            this.setState({
              sendData: false,
            });
            this.showPopup('success', 'Ваши данные успешно сохранены.');
            location.reload();
          } else {
            this.setState({
              loading: false,
            });

            this.showPopup(
              'error',
              json.errors.message || 'Что-то пошло не так. Попробуйте еще раз.',
              () => {
                document.location.href = '/login';
              },
            );
          }
        }
      })
      .catch(error => {
        if (sendData) {
          this.setState({
            sendData: false,
          });
          this.showPopup('success', 'Ваши данные успешно сохранены.');
          location.reload();
        } else {
          this.setState({
            loading: false,
            error: 'Что-то пошло не так. Попробуйте еще раз.',
          });

          this.showPopup('error', 'Что-то пошло не так. Попробуйте еще раз.');
        }
      });
  }

  confirm = e => {
    e.preventDefault();

    const {
      route: { edit },
    } = this.props;

    let formData = new FormData(this.form);

    let headers = {
      method: 'POST',
      body: formData,
      headers: {},
    };

    this.setState({
      sendData: true,
      error: null,
    });

    // send data
    fetch(edit, headers)
      .then(response => response.json())
      .then(json => {
        if (json.status == 'success') {
          this.loadData();
        } else if (json.status == 'error') {
          this.setState({
            sendData: false,
            error: json.errors.message,
          });

          this.showPopup(
            'error',
            json.errors.message || 'Что-то пошло не так. Попробуйте еще раз.',
          );
        }
      })
      .catch(error => {
        this.setState({
          sendData: false,
        });

        this.showPopup(
          'error',
          `Что-то пошло не так: ${error}. Попробуйте еще раз.`,
        );
      });
  };

  // Вывод попапа с результатом
  showPopup(status, message, func) {
    $.magnificPopup.open({
      items: {
        src: '#popup',
      },
      removalDelay: 250,
      callbacks: {
        beforeOpen: function() {
          this.st.mainClass = 'mfp-anim';
        },
        open: function() {
          render(
            <Popup
              type="alert"
              status={status}
              title={status == 'success' ? 'Отлично!' : 'Ошибка'}
              message={message}
              button="Назад в профиль"
              func={func}
            />,
            $('#popup')[0],
          );
        },
        close: function() {
          remove($('#popup')[0]);
        },
      },
    });
  }

  render() {
    const { success, sendData, error, file, accept_rules, key } = this.state;
    const { data } = this.props;

    if (success)
      return (
        <Popup
          type="alert"
          status="success"
          title="Отлично!"
          message="Ваши данные сохранены."
          button="Назад в профиль"
        />
      );

    const formBody = (
      <div className="inp-group">
        <div className="row">
          <div className="inp-group__case">
            <Input
              label="Фамилия"
              name="last_name"
              placeholder="Фамилия"
              value={data.last_name || ''}
              lang="rus"
              indie
              required
            />
          </div>
          <div className="inp-group__case">
            <Input
              label="Имя"
              name="first_name"
              placeholder="Имя"
              value={data.first_name || ''}
              lang="rus"
              indie
              required
            />
          </div>
          <div className="inp-group__case">
            <Input
              label="Отчество"
              name="patronymic"
              placeholder="Отчество"
              value={data.patronymic || ''}
              lang="rus"
              indie
              required
            />
          </div>
          <div className="inp-group__case">
            <Input
              label="E-mail"
              name="email"
              placeholder="Укажите e-mail"
              value={data.email || ''}
              indie
              required
            />
          </div>
          <div className="inp-group__case">
            <Input
              label="Дата рождения"
              name="birthday"
              date
              placeholder="дд.мм.гггг"
              value={data.birthday || ''}
              indie
              required
            />
          </div>
          <div className="inp-group__case">
            <div className="round-checks">
              <RoundCheck
                checked={data.gender == 0}
                icon="female"
                label="Женский"
                name="gender"
                value={0}
              />
              <RoundCheck
                checked={data.gender == 1}
                icon="male"
                label="Мужской"
                name="gender"
                value={1}
              />
            </div>
          </div>
          {data.accept_rules === null || (data && data.accept_rules == 0) ? (
            <div className="inp-group__case">
              <Checkbox
                checked={accept_rules == 1}
                name="accept_rules"
                value={accept_rules}
                label={
                  <p>
                    Согласие на&nbsp;обработку{' '}
                    <a href={data.pd} target="_blank" className="link">
                      персональных&nbsp;данных
                    </a>
                  </p>
                }
              />
            </div>
          ) : null}
        </div>
      </div>
    );

    let btnClasses = ['btn'];

    if (sendData) btnClasses.push('btn--loading');

    return (
      <div className="popup" data-type="vacancy">
        <div className="popup__aside">
          <div className="card-popup__pic" />
        </div>
        <form
          className="popup__content"
          ref={node => (this.form = node)}
          onSubmit={this.confirm}
        >
          <div className="popup__content-inner">
            <div className="popup__section-title">
              <h3 className="heading heading--1 popup__title">
                Заполните ваши данные
              </h3>
            </div>
            {data ? formBody : null}
            <div className="popup__btn-wrap">
              {error ? <p>{error}</p> : null}
              <div className="wrap">
                <button className={btnClasses.join(' ')} type="submit">
                  Сохранить
                </button>
              </div>
            </div>
          </div>
        </form>
        <button className="popup__close" type="button">
          <svg viewBox="0 0 18 18" width="18" height="18">
            <path d="M15.5 17.6l-6.5-6.5-6.5 6.5c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1l6.5-6.5-6.5-6.5c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l6.5 6.5 6.5-6.5c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-6.5 6.5 6.5 6.5c.6.6.6 1.5 0 2.1-.3.3-.6.4-1 .4s-.8-.2-1.1-.4z"></path>
          </svg>
        </button>
      </div>
    );
  }
}

export default VerifyPopup;
